/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ResearchMenuItems from "./ResearchMenuItems";
import { PatientAuthContext } from "../../contexts/PatientAuthContext";

import LogoWhite from "../../assets/img/logo/logo-white-4.png";

const HeaderResearch = (props) => {
  const { headerClass, headerLogo, isOnePage } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { patient, logout } = useContext(PatientAuthContext);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <header className={headerClass ? headerClass : ""}>
        <div className="it-header-top-area it-header-top-style-2">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-5 col-xl-4 col-lg-3 col-md-4">
                <div className="it-header-top__left d-flex align-items-center">
                  {patient ? (
                    <div className="d-none d-md-flex align-items-center gap-2" style={{ color: "#fff", fontSize: "0.875rem" }}>
                      <i className="fa-regular fa-user-circle" style={{ marginRight: "6px" }}></i>
                      <span style={{ fontWeight: 600 }}>{patient.mrno}</span>
                      <span style={{ margin: "0 8px", opacity: 0.5 }}>|</span>
                      <Link to="/patient-profile" style={{ color: "#fff", textDecoration: "underline", fontSize: "0.8rem" }}>
                        My Profile
                      </Link>
                      <span style={{ margin: "0 8px", opacity: 0.5 }}>|</span>
                      <button
                        onClick={logout}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#fff",
                          cursor: "pointer",
                          fontSize: "0.8rem",
                          padding: 0,
                          textDecoration: "underline",
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  ) : (
                    <div className="d-none d-md-block">
                      <Link to="/patient-login" style={{ color: "#fff", fontSize: "0.875rem", fontWeight: 500 }}>
                        <i className="fa-regular fa-user" style={{ marginRight: "6px" }}></i>
                        Patient Login
                      </Link>
                      <span style={{ margin: "0 8px", opacity: 0.5 }}>|</span>

                      <Link to="/appointment" style={{ color: "#fff", fontSize: "0.875rem", fontWeight: 500 }}>
                        <i className="fa-regular fa-calendar" style={{ marginRight: "6px" }}></i>
                        Book Appointment
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xxl-7 col-xl-8 col-lg-9 col-md-8">
                <div className="it-header-top-content text-center text-md-end">
                  <ul>
                    <li className="d-none d-sm-inline-block">
                      <div>
                        <a
                          href="tel:+92-51-111-644-911"
                          style={{
                            background: "#fff",
                            color: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                            padding: "6px 14px",
                            borderRadius: "999px",
                            fontWeight: 700,
                            fontSize: "0.82rem",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            boxShadow: "0 2px 8px rgba(220,38,38,0.4)",
                            animation: "rsPulse 2s ease-in-out infinite",
                          }}
                          aria-label="24/7 Emergency Helpline"
                        >
                          <i className="fa-solid fa-truck-medical" style={{ fontSize: "0.95rem" }}></i>
                          <span style={{ color: "#fff" }}>24/7 Emergency: 111-644-911</span>
                        </a>
                        <style>{`@keyframes rsPulse { 0%,100%{transform:scale(1);} 50%{transform:scale(1.04);} }`}</style>
                      </div>
                    </li>
                    <li>
                      <div>
                        <a href="mailto:info@maroof.com.pk">
                          <i className="flaticon-letter"></i>
                          <span className="hover-anim white">info@maroof.com.pk</span>
                        </a>
                      </div>
                    </li>
                    <li className="d-none d-lg-inline-block">
                      <div>
                        <a
                          target="_blank"
                          href="https://www.google.com/maps/place/Maroof+International+Hospital/@33.6974641,73.0090763,17z/data=!3m1!4b1!4m6!3m5!1s0x38dfbe6b77fc7279:0x855a61d1ef5e9def!8m2!3d33.6974597!4d73.0116512!16s%2Fg%2F1hdzv62pm!5m2!1e4!1e1?entry=ttu&g_ep=EgoyMDI2MDMyNC4wIKXMDSoASAFQAw%3D%3D"
                          rel="noreferrer"
                        >
                          <i className="flaticon-location"></i>
                          <span className="hover-anim white">F-10 Markaz, ISB, PK</span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="header-sticky"
          className={
            isVisible
              ? "it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg header-sticky"
              : "it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg"
          }
        >
          <div className="container">
            <div className="p-relative">
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-6 col-6">
                  <div className="it-header-logo">
                    <Link to="/">
                      <img src="images/logo/logo-full.png" alt="" />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-10 d-none d-xl-block">
                  <div className="it-header-main-menu it-main-menu">
                    <nav className="it-menu-content">
                      <ResearchMenuItems />
                    </nav>
                  </div>
                </div>
                <div className="col-lg-6 col-6 d-xl-none">
                  <div style={{ padding: 4 }} className="it-header-button d-flex align-items-center justify-content-end">
                    <div className="it-header-bar">
                      <button className="it-menu-bar" onClick={() => setIsOffCanvasOpen(true)}>
                        <span>
                          <i className="fa-regular fa-bars-sort"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="itoffcanvas__close-btn">
            <button className="close-btn" onClick={() => setIsOffCanvasOpen(false)}>
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoWhite} alt="" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>Suspendisse interdum consectetur libero id. Fermentum leo vel orci porta non. Euismod viverra nibh cras pulvinar suspen.</p>
          </div>
          <div className="it-menu-mobile">
            <ResearchMenuItems isMobileMenu />
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a href="htits://www.google.com/maps/@37.4801311,22.8928877,3z" target="_blank" rel="noreferrer">
                  Riverside 255, San Francisco, USA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div className="body-overlay apply" onClick={() => setIsOffCanvasOpen(false)}></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderResearch;
